import React from 'react';

const Tech = () => {
  return (
    <section lang="en-US" className="tech" title="Information about tech-stack" aria-label="Information about tech-stack">
      <h2>Tech</h2>
      <p>
          HTML, CSS, Flexbox, <mark className="pink-bg-text">JavaScript,</mark> ES6, JSX, <mark className="blue-bg-text">React,</mark> React Hooks, Redux, <mark className="light-blue-bg-text">Redux Toolkit,</mark> Node.js, Mongo DB, Express.js, Web Accessibly, API:s, pair-programming, Github.
      </p>
    </section>
  )
};

export default Tech;